// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyDIQWQnsn4OTWk1H7o3tIx9EoRRDhY6hA8",
  authDomain: "ecokaz-d1eb0.firebaseapp.com",
  projectId: "ecokaz-d1eb0",
  storageBucket: "ecokaz-d1eb0.appspot.com",
  messagingSenderId: "751471135884",
  appId: "1:751471135884:web:eef819330f7042423a7fa9",
  measurementId: "G-HVMT4C47BQ"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export const auth = getAuth();
export const db = getFirestore(app);

export default app;